import React, { useEffect, useState, useRef } from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import { Helmet } from "react-helmet";

const API_PDF_URL = process.env.REACT_APP_API_PDF_URL;
const BASE_URL = process.env.REACT_APP_BASE_URL;

const ResearchReport = () => {
  const pageid = 9; // <-- set correct pageid for Research Reports from backend
  const [researchReports, setResearchReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const yearRefs = useRef({});

  useEffect(() => {
    const fetchReports = async () => {
      try {
        const response = await fetch(`${BASE_URL}?pageid=${pageid}`);
        if (!response.ok) throw new Error(`HTTP error! ${response.status}`);
        const result = await response.json();

        if (!result.success || !Array.isArray(result.data)) {
          setResearchReports([]);
          setLoading(false);
          return;
        }

        // Group reports by year_name
        const grouped = {};
        result.data.forEach((item) => {
          const year = item.year_name;
          if (!grouped[year]) grouped[year] = [];
          grouped[year].push({
            label: item.pdf_name,
            file: item.upload_file_path,
          });
        });

        // Convert grouped object to sorted array
        const finalData = Object.keys(grouped)
          .map((year) => ({
            year,
            reports: grouped[year],
          }))
          .sort((a, b) => b.year - a.year);

        setResearchReports(finalData);
      } catch (error) {
        console.error("Fetch failed:", error);
        setResearchReports([]);
      } finally {
        setLoading(false);
      }
    };

    fetchReports();
  }, []);

  // Scroll to first year section
  useEffect(() => {
    if (researchReports.length > 0) {
      const el = yearRefs.current[researchReports[0].year];
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  }, [researchReports]);

  return (
    <>
      <Helmet>
        <title>Research Reports | Nandan Denim Ltd.</title>
      </Helmet>
      <Header />
      <div>
        {/* Hero Section */}
        <div className="relative w-full">
          <img
            src="./imgs/investors/investorresearchreport.png"
            alt="Chiripal Group Banner"
            className="object-cover w-full h-full md:h-[70vh] lg:h-[80vh] xl:h-[88vh]"
          />
          <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center">
            <div className="px-4 sm:px-8 md:px-16 lg:px-32">
              <h1 className="text-yellow-400 text-3xl sm:text-5xl md:text-7xl font-montserrat font-bold text-left">
                Research Reports
              </h1>
            </div>
          </div>
        </div>

        {/* PDF Section */}
        <div className="py-12 px-4 font-signika max-w-7xl mx-auto">
          {loading ? (
            <p>Loading research reports...</p>
          ) : researchReports.length === 0 ? (
            <p>No research reports found.</p>
          ) : (
            researchReports.map((yearGroup, index) => (
              <div
                key={index}
                ref={(el) => (yearRefs.current[yearGroup.year] = el)}
                className="mb-10"
              >
                <h2 className="text-2xl font-extrabold text-[#0b3a6a] uppercase mb-4">
                  For the Year {yearGroup.year}
                </h2>
                <ul className="list-disc pl-5 text-[#0b3a6a] font-medium space-y-2">
                  {yearGroup.reports.map((report, idx) => (
                    <li key={idx}>
                      <a
                        href={report.file ? `${API_PDF_URL}/${report.file}` : "#"} // ✅ Use # if no PDF
                        target={report.file ? "_blank" : "_self"}
                        rel="noopener noreferrer"
                        className="hover:underline"
                      >
                        {report.label}
                      </a>
                    </li>
                  ))}
                </ul>
                <hr className="mt-4 border-gray-300" />
              </div>
            ))
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ResearchReport;
